const CheckIcon = ({ iconStyle }) => {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={iconStyle}
    >
      <path
        d='M40 0C17.9431 0 0 17.9431 0 40C0 62.0569 17.9431 80 40 80C62.0569 80 80 62.0569 80 40C80 17.9431 62.0569 0 40 0Z'
        fill='#4C9D8A'
      />
      <path
        d='M60.2729 31.5229L38.6061 53.1892C37.9561 53.8392 37.1028 54.1664 36.2495 54.1664C35.3962 54.1664 34.543 53.8392 33.8929 53.1892L23.0598 42.3561C21.7561 41.053 21.7561 38.946 23.0598 37.6429C24.3629 36.3392 26.4692 36.3392 27.7729 37.6429L36.2495 46.1195L55.5598 26.8098C56.8629 25.5061 58.9692 25.5061 60.2729 26.8098C61.576 28.1129 61.576 30.2192 60.2729 31.5229Z'
        fill='#FAFAFA'
      />
    </svg>
  );
};

export default CheckIcon;
